module.exports = __webpack_public_path__ + "static/media/NIZHA AHMED.ca604a36.png";